export default "__VITE_ASSET__CesHLxVD__ 480w, __VITE_ASSET__mIq67xD2__ 686w";